import Lenis from 'lenis';

function initLenis() {
  const isMobile = window.matchMedia('(max-width: 992px)').matches;

  const lenis = new Lenis({
    autoRaf: true,
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    syncTouch: false,
    lerp: isMobile ? 0.14 : 0.085,
    overscroll: true,
    autoResize: true,
    anchors: {
      offset: 0,
      duration: 1,
      easing: (t) => 1 - Math.pow(1 - t, 4)
    },
    prevent: (node) => {
      return !!node?.closest(
        '[data-lenis-prevent], .modal, .popup, .menu-overlay, .js-native-scroll'
      );
    }
  });

  return lenis;
}

document.addEventListener('DOMContentLoaded', () => {
  initLenis();
});

document.addEventListener('DOMContentLoaded', () => {
    // Зберігаємо екземпляр у window, щоб інші скрипти мали до нього доступ
    window.lenis = initLenis(); 
});